import { Module, VuexModule, Mutation } from 'vuex-module-decorators';
import { Event } from './events';

/**
 * 🧩 Module which provides a general event bus
 */
@Module
export default class EventbusModule extends VuexModule {
  
  // 📦 The type of event
  public event: Event | null = null;

  /**
   * 👾 Mutation which sets the event
   */
  @Mutation
  public publishEvent(event: Event) {
    this.event = event;

    if (event != null) {
      this.event = null;
    }
  }
}